// @ts-expect-error React import required to render in Jira SSR
import React from 'react';
import { getDocument } from '@atlaskit/browser-apis';

// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import Spotlight from '@atlaskit/onboarding/spotlight';

import { Pulse as SpotlightPulse } from '@atlaskit/onboarding/target';

// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import SpotlightTransition from '@atlaskit/onboarding/spotlight-transition';

import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';

import { type PropsWithChildren, useCallback, useEffect, useState } from 'react';

import { useIntl } from 'react-intl';

import { spotlightMessages } from './messages';

import { token } from '@atlaskit/tokens';

import { type JSX } from 'react/jsx-runtime';

export const ExportIssuesFlyoutSpotlight = ({ children }: PropsWithChildren): JSX.Element => {
	const [isActive, setIsActive] = useState(true);

	const { onAcknowledged, onClosed } = usePostOfficeUserInteractions();
	const { formatMessage } = useIntl();

	const handleAcknowledge = useCallback(() => {
		setIsActive(false);
		void onAcknowledged({ interactionIdentifier: 'okButton' });
	}, [onAcknowledged]);

	// Escape is `closed`, not `acknowledged` — the user made no choice.
	const handleClose = useCallback(() => {
		setIsActive(false);
		void onClosed({ interactionIdentifier: 'escape' });
	}, [onClosed]);

	useEffect(() => {
		const handleEscape = (ev: KeyboardEvent) => {
			if (ev.key === 'Escape') {
				handleClose();
			}
		};

		getDocument()?.addEventListener('keydown', handleEscape);

		return () => {
			getDocument()?.removeEventListener('keydown', handleEscape);
		};
	}, [handleClose]);

	return (
		<>
			<SpotlightPulse radius={token('radius.medium', '3px')} pulse={isActive}>
				{children}
			</SpotlightPulse>
			{isActive && (
				<SpotlightTransition>
					<Spotlight
						actions={[
							{
								onClick: handleAcknowledge,
								text: formatMessage(spotlightMessages.spotlightOkButton),
								appearance: 'default',
							},
						]}
						heading={formatMessage(spotlightMessages.spotlightHeading)}
						target="nin.page-actions.meatball-menu-popup-exports"
						key="nin.page-actions.meatball-menu-popup-exports"
						targetRadius={token('radius.medium', '3px')}
						dialogWidth={270}
						targetBgColor={token('elevation.surface')}
						pulse={true}
						testId="export-issues-flyout-spotlight"
						dialogPlacement="left top"
					>
						{formatMessage(spotlightMessages.spotlightBody)}
					</Spotlight>
				</SpotlightTransition>
			)}
		</>
	);
};
